import { Star } from '../../Svg/Star';
import styles from './Stars.module.scss';

interface StarsProps {
  stars?: number | null;
}
const starsLength = 5;
const yellowStar = '#F2C94C';

export const Stars = ({ stars }: StarsProps) => {
  return (
    <span className={styles.stars} data-ui="player-stars">
      {[...Array(starsLength)].map((e, i) => {
        if (stars && stars > i) {
          return <Star fill={yellowStar} key={i} />;
        }

        return <Star key={i} />;
      })}
    </span>
  );
};
